import { render, staticRenderFns } from "./vehicle-three-check-cfg.vue?vue&type=template&id=2dcdd851&"
import script from "./vehicle-three-check-cfg.vue?vue&type=script&lang=js&"
export * from "./vehicle-three-check-cfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports